import React, { memo } from 'react';
import { t } from 'ttag';

function Flagship() {
  return (
    <a
      href="/about/flagship/"
      className="block p-1 text-black outline-none hover:underline focus:outline-none"
    >
      <span className="text-base">{t`Find Store`}</span>
    </a>
  );
}

export default memo(Flagship);
